<template>
  <!-- 工单接入到淘金客投诉反馈使用场景 http://s.itaojin.cn/ticket/t/XT20191225102302895 -->

  <div :style="'width:' + ( width ? width : '100%;')">
    <!-- 已选 -->
    <transition :duration="100" name="slide-fade">
      <div style="width:100%;margin:0 15px;">
        <template v-for="(e, i) in selectedList">
          <div
            title="点我可取消, 重新选择"
            @click="onClickCancel(e, i)"
            :key="e.id"
            class="item_0 item_0_selected">
              <van-icon name="certificate" class="van-button__icon"/>
              <span>{{e.name}}</span>
            </div>
        </template>
      </div>
    </transition>

    <!-- 分割 -->
    <div style="height:10px;"
      v-if="ticketTypeOption && ticketTypeOption.length > 0  && selectedList && selectedList.length > 0"></div>

    <!-- 待选 -->
    <transition :duration="100" name="slide-fade">
      <van-radio-group
        v-if="ticketTypeOption && ticketTypeOption.length > 0"
        style="width:100%;margin:0 15px;">
        <template v-for="e in ticketTypeOption">
          <div class="item_0"
            :class="(!!lastSelected && e.id == lastSelected.id) ? 'item_0_selected' : ''"
            @click="onClickSelect(e)"
            :key="e.id">
              <van-icon :name="(!!lastSelected && e.id == lastSelected.id) ? 'certificate' : 'circle'" class="van-button__icon"/>
              <span>{{e.name}}</span>
            </div>
        </template>
      </van-radio-group>
    </transition>
  </div>
</template>

<script>
import AbstractTicketTypeSelect from '@/assets/mixins/AbstractTicketTypeSelect';

export default {
  name: "MobileTicketTypePicker",

  mixins : [ AbstractTicketTypeSelect ],

  props: ["value", 'width'],

  data() {
    return {
      lastSelected : null,
      selectedList : [],
      ticketTypeOption: []
    };
  },

  watch : {
    value() {
      this.loadType();
    }
  },

  mounted() {
    this.loadType();
  },

  methods: {
    loadType() {
      // console.log('#72 MobileTicketTypePicker.loadType', this);

      if ( !!this.value && '' != this.value) {
        this.loadTicketTypeByParentId(this.value);
      } else {
        this.loadRootTicketType();
      }
    },

    reset() {
      this.selectedList = [];
      this.loadRootTicketType();
    },

    emitInput() {
      if ( !this.lastSelected ) {
        this.$emit('input', null);
        this.$emit('change', null, null);
        return;
      }

      this.$emit('input', this.lastSelected.id);
      this.$emit('change', this.lastSelected.id, this.lastSelected);
    },

    onClickCancel( e, i ) {
      this.ticketTypeOption = [];
      this.loadTicketTypeByBrotherId(e.id);
      this.selectedList = this.selectedList.slice(0, i);

      this.emitInput();
      return false;
    },

    onClickSelect( _each ) {
      this.lastSelected = _each;
      this.loadTicketTypeByParentId( _each.id, _each );

      this.emitInput();
      return false;
    },

    loadTicketTypeByBrotherId( _brotherId ) {
      var _this = this;
      sdk.TicketTypeApi().listByBrotherIdCached({
          brotherId: _brotherId,
          page: { pageSize: 9999 , orderBy : '`index` DESC'}
        }).then(page => {
          _this.ticketTypeOption = page.list;

          if ( !_this.ticketTypeOption || _this.ticketTypeOption.length < 1 ) {
            console.log('#121 no_sub_item', _parentId, _each, _this);

            _this.$emit('no_sub_item', null);
          }
        });
    },

    loadTicketTypeByParentId( _parentId, _each ) {
      var _this = this;
      sdk.TicketTypeApi().listByParentId({
        parentId: _parentId,
        page: { pageSize: 9999, orderBy : '`index` DESC' }
      }).then(page => {
        if ( !page.list || page.list.length < 1 ) {
          // console.log('#135 no_sub_item', _parentId, _each, _this);

          _this.$emit('no_sub_item', null);
        } else {
          if ( !!_each ) {
            _this.selectedList.push(_each); // 有下级的，折叠上级，展示下级，无下级的，在本级勾选
          }

          _this.ticketTypeOption = page.list;
          _this.$forceUpdate();
        }
      });
    },

    getTypeSelected() {
      var _list = this.selectedList;

      if ( !!this.lastSelected ) {
        _list = _list.concat(this.lastSelected);
      }

      if ( !!_list && _list.length > 0 ) {
        return _list //
          .map(e => e.name + '(' + e.id + ')') //
          .join(' > ');
      }

      console.log('#166 getTypeSelected return null', this);
      return "";
    },

    loadRootTicketType() {
      var _this = this;

      // 一级分类
      sdk.TicketTypeApi().listRootCached({
          page: { pageSize: 9999, orderBy : '`index` DESC' }
        }).then(page => {
          _this.ticketTypeOption = page.list;
          _this.$forceUpdate();
        });
    }
  }
};
</script>

<style scoped>
  .selected_1 {
    width:45%;
    margin:1px;
    text-align:left;
  }

  .item_0 {
    cursor:pointer;
    display:inline-block;
    background-color: #fff;
    border: 1px solid #ebedf0;
    width:45%;
    margin: 1px;
    text-align:left;
    min-width: 60px;
    height: 30px;
    padding: 0 8px;
    font-size: 12px;
    line-height: 28px;
  }

  .item_0:hover {
    box-shadow: 1px 1px 10px 5px #e6e9da;
  }

  .item_0_selected {
    border-color: #7370d4;
    background: rgb(204,232,255);
    color: #4566e6;
  }
</style>


// WEBPACK FOOTER //
// src/components/mobile-ticket/MobileTicketTypePicker.vue